module.exports = __webpack_public_path__ + "static/media/cup.07a62d76.png";